export const SET_PRODUCT = "SET_PRODUCT";
export const SET_PRODUCT_LIST = "SET_PRODUCT_LIST";
export const SET_PRODUCT_SINGLE = "SET_PRODUCT_SINGLE";
